<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m1vTEU/tc-custom/9780547524900.jpg?1736424461180" alt="This image is the cover for the book Welsh Girl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Welsh Girl
      </h1>
      <p class="bookDescription body article font2">
        <b>A WWII-era Welsh barmaid begins a secret relationship with a German POW in this “beautiful” novel by the author of <i>A Lie Someone Told You About Yourself</i> (Ann Patchett).</b><br/>  <i>Longlisted for the Man Booker Prize</i><br/>  <br/> Set in the stunning landscape of North Wales just after D-Day, this critically acclaimed debut novel traces the intersection of disparate lives in wartime. When a prisoner-of-war camp is established near her village, seventeen-year-old barmaid Esther Evans finds herself strangely drawn to the camp and its forlorn captives. She is exploring the camp boundary when an astonishing thing occurs: A young German corporal calls out to her from behind the fence. From that moment on, the two begin an unlikely—and perilous—romance.<br/>  <br/> Meanwhile, a German-Jewish interrogator travels to Wales to investigate Britain’s most notorious Nazi prisoner, Rudolf Hess. In this richly drawn and thought-provoking “tour de force,” all will come to question the meaning of love, family, loyalty, and national identity (<i>The New Yorker</i>).<br/>  <br/> “If you loved <i>The English Patient</i>, there’s probably a place in your heart for <i>The Welsh Girl</i>.” —<i>USA Today</i><br/>  <br/> “Davies’s characters are marvelously nuanced.” —<i>Los Angeles Times</i><br/>  <br/> “Beautifully conjures a place and its people, in an extraordinary time . . . A rare gem.” —Claire Messud, author of <i>The Woman Upstairs</i><br/>  <br/> “This first novel by Davies, author of two highly praised short story collections, has been anticipated—and, with its wonderfully drawn characters, it has been worth the wait.” —<i>Booklist</i>, starred review
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter  Ho Davies
      </h2>
      
      <p class="authorDescription body article">Peter&#160;Ho&#160;Davies&#160;is on the faculty of the graduate program in creative writing at the University of Michigan. His debut collection,&#160;<I>The Ugliest House in the World,&#160;</I>won the John Llewellyn Rhys and PEN/Macmillan awards in Britain. His second collection, <I>Equal Love,</I> was hailed by the <I>New York Times Book Review </I>for its &ldquo;stories as deep and clear as myth.&rdquo; It was a finalist for the <I>Los Angeles Times </I>Book Prize and a <I>New York Times </I>Notable Book. In 2003 Davies was named among the &ldquo;Best of Young British Novelists&rdquo; by <I>Granta. The Welsh Girl</I> was his first novel and his second, <I>The Fortunes,</I> was published in September 2016. The son of a Welsh father and Chinese mother, Davies was raised in England and spent his summers in Wales.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1971c57c